<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
              <v-layout row wrap>
                 <v-flex d-flex xs12 style="margin-top: 20px">
                  <v-layout column>
                    <v-flex d-flex>
                      <v-card style="">
                        <v-card-text>
                          <h3 style="text-align: left;margin-bottom: 10px">Service Location / Hub Report</h3>
                          <v-btn flat class="primary" style="margin-left:900px;margin-bottom: 10px;margin-top:-40px" v-on:click="back()">Back</v-btn>
                          <v-divider divider: true></v-divider>
                          <v-layout row wrap>
                            <v-flex xs3 child-flex>
                              <v-layout row wrap>
                                <label style="margin-top:20px;margin-right: 10px">Show</label>
                                <v-overflow-btn
                                  :items="dropdown_list"
                                  label=""
                                  target="#dropdown-example"
                                ></v-overflow-btn>
                                <label style="margin-top:20px;margin-left: 10px">Entries</label>
                              </v-layout>
                            </v-flex>
                            <v-flex xs3 child-flex></v-flex>
                            <v-flex xs6 child-flex>
                              <v-layout row wrap>
                                <v-text-field
                                  label="Search"
                                ></v-text-field>
                                <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                                <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>list</v-icon></v-btn>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                          <v-data-table
                            :headers="headers"
                            :items="desserts"
                            class="elevation-1"
                            style="width:1200px"
                          >
                            <template slot="items" slot-scope="props">
                              <td>{{ props.item.no}}</td>
                              <td class="text-xs-left">{{ props.item.locationname }}</td>
                              <td class="text-xs-left">{{ props.item.region }}</td>
                              <td class="text-xs-left">{{ props.item.city }}</td>
                              <td class="text-xs-left">{{ props.item.address }}</td>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Service Location Name', value: 'locationname' },
        { text: 'Region', value: 'region' },
        { text: 'City', value: 'city' },
        { text: 'Address', value: 'address' }
      ],
      desserts: [
        {
          no: '1',
          locationname: 'Nagpur',
          region: 'West',
          city: 'Nagpur',
          address: 'Wardha Road, Dhantoli, Nagpur, Maharashtra'
        },
        {
          no: '2',
          locationname: 'Mumbai',
          region: 'West',
          city: 'Mumbai',
          address: 'Mulund,Vijay Nagar, Mumbai, Maharashtra'
        }
      ]
    }
  },
  methods: {
    back () {
      this.$router.push('/Truckingservicelocation')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Truckingservicelocationreport.vue